export const MUT_GET_CONTACTS = 'MUT_GET_CONTACTS';
export const MUT_SET_CONTACTS = 'MUT_SET_CONTACTS';
export const MUT_ERR_CONTACTS = 'MUT_ERR_CONTACTS';
